import clsx from 'clsx';

const formInputWrapper = (hasWidth, hasFlex, layoutClassName, highlighted) => clsx(!hasFlex && 'flex-1', !hasWidth && 'w-full', layoutClassName, highlighted && '-m-2.5 p-2.5 rounded-md bg-brand-200');
const labelWrapper = clsx('mb-1.5');
var styles = {
    formInputWrapper,
    labelWrapper,
};

export { styles as default };
